{
  "404": {
    "title": "Ukurasa huu haupatikani.",
    "text": "Ikiwa unahisi haikuwa sahihi, tuma ujumbe kwetu kwa ",
    "back_button": "Rudi kwenye dashibodi"
  },
  "auth": {
    "agree": "Nakubali",
    "createAccount": "Fungua akaunti",
    "createNewAccount": "Fungua Akaunti Mpya",
    "email": "Barua pepe",
    "login": "Ingia",
    "password": "Neno la siri",
    "recover_password": "Rudisha neno la siri",
    "sign_up": "Jiandikishe",
    "keep_logged_in": "Niendelee kuwa nimeingia",
    "termsOfUse": "Masharti ya Matumizi.",
    "reset_password": "Weka upya neno la siri",
    "layout": {
      "tagline": "Jukwaa la Video za Vichekesho Tanzania",
      "backToVideos": "Rudi kwenye video (Back to Videos)"
    },
    "loginPage": {
      "title": "Ingia Kicheko",
      "noAccount": "Huna akaunti bado?",
      "signUpLink": "Jisajili",
      "usernameLabel": "Barua pepe au Namba ya simu",
      "usernamePlaceholder": "email{'@'}example.com au +255...",
      "passwordLabel": "Nenosiri",
      "rememberDevice": "Nikumbuke kifaa hiki",
      "forgotPassword": "Umesahau nenosiri?",
      "submit": "Ingia",
      "welcomeToast": "Karibu tena Kicheko!",
      "failed": "Kuingia kumeshindikana. Tafadhali angalia taarifa zako."
    },
    "signupPage": {
      "title": "Jisajili Kicheko",
      "haveAccount": "Tayari una akaunti?",
      "loginLink": "Ingia hapa",
      "nameLabel": "Jina lako kamili au la Sanaa",
      "namePlaceholder": "e.g. Joti Mchekeshaji",
      "emailLabel": "Barua pepe",
      "emailPlaceholder": "wewe{'@'}example.com",
      "passwordLabel": "Nenosiri",
      "passwordHint": "Inatakiwa herufi 8+, namba, na alama maalum.",
      "confirmLabel": "Thibitisha Nenosiri",
      "confirmRequired": "Tafadhali thibitisha nenosiri",
      "passwordsMismatch": "Nenosiri halilingani",
      "acceptTerms": "Ninakubali Vigezo vya Huduma na Sera ya Faragha",
      "acceptTermsRequired": "Lazima ukubali vigezo na masharti",
      "submit": "Jisajili",
      "welcomeToast": "Karibu Kicheko! Akaunti yako iko tayari.",
      "failed": "Kujisajili kumeshindikana. Tafadhali angalia taarifa zako.",
      "passwordRequired": "Tafadhali ingiza nenosiri",
      "passwordMinLength": "Nenosiri liwe na angalau herufi 8",
      "passwordLetter": "Nenosiri liwe na angalau herufi moja",
      "passwordNumber": "Nenosiri liwe na angalau namba moja",
      "passwordSpecial": "Nenosiri liwe na angalau alama moja maalum"
    },
    "passwordReset": {
      "title": "Umesahau nenosiri?",
      "intro": "Ingiza barua pepe yako na tutakutumia msimbo wa tarakimu 6 wa kuweka upya nenosiri lako.",
      "emailLabel": "Ingiza barua pepe yako",
      "sendCode": "Tuma msimbo",
      "goBack": "Rudi nyuma",
      "checkEmail": "Angalia barua pepe yako",
      "codeSent": "Ikiwa akaunti ya {email} ipo, tumetuma msimbo wa tarakimu 6. Unaisha baada ya dakika 10.",
      "otpLabel": "Msimbo wa tarakimu 6",
      "otpInvalid": "Ingiza msimbo wa tarakimu 6",
      "verifyCode": "Thibitisha msimbo",
      "differentEmail": "Tumia barua pepe nyingine",
      "newPasswordTitle": "Weka nenosiri jipya",
      "newPasswordLabel": "Nenosiri jipya",
      "repeatLabel": "Rudia nenosiri jipya",
      "repeatRequired": "Tafadhali rudia nenosiri",
      "passwordsDontMatch": "Nenosiri halilingani",
      "submit": "Weka upya nenosiri",
      "doneTitle": "Nenosiri limesasishwa",
      "doneText": "Nenosiri lako limewekwa upya. Sasa unaweza kuingia kwa nenosiri jipya.",
      "backToLogin": "Rudi kuingia",
      "genericError": "Hitilafu imetokea. Tafadhali jaribu tena."
    },
    "orContinueWith": "Au endelea kwa",
    "google": {
      "welcomeToast": "Karibu Kicheko!",
      "failed": "Kuingia kwa Google kimeshindwa. Jaribu tena."
    }
  },
  "validators": {
    "required": "Sehemu hii inahitajika",
    "email": "Tafadhali ingiza barua pepe sahihi"
  },
  "typography": {
    "primary": "Mitindo ya maandishi ya msingi",
    "secondary": "Mitindo ya maandishi ya sekondari"
  },
  "dashboard": {
    "versions": "Toleo",
    "setupRemoteConnections": "Weka Miunganiko ya Mbali",
    "currentVisitors": "Wageni wa Sasa",
    "navigationLayout": "mpangilio wa urambazaji",
    "topBarButton": "Upau wa Juu",
    "sideBarButton": "Upau wa Pembeni"
  },
  "language": {
    "brazilian_portuguese": "Kireno (Brazil)",
    "english": "Kiingereza",
    "spanish": "Kihispania",
    "simplified_chinese": "Kichina (Rahisi)",
    "persian": "Kiajemi",
    "swahili": "Kiswahili"
  },
  "menu": {
    "404": "404",
    "auth": "Uthibitishaji",
    "buttons": "Vitufe",
    "timelines": "Ratiba",
    "dashboard": "Dashibodi",
    "billing": "Bili",
    "login": "Ingia",
    "preferences": "Mapendeleo ya akaunti",
    "payments": "Malipo",
    "settings": "Mipangilio ya programu",
    "pricing-plans": "Mipango ya bei",
    "payment-methods": "Njia za malipo",
    "signup": "Jiandikishe",
    "recover-password": "Rudisha neno la siri",
    "recover-password-email": "Barua pepe ya kurejesha neno la siri",
    "faq": "Maswali Yanayoulizwa Mara Kwa Mara",
    "users": "Watumiaji",
    "projects": "Miradi"
  },
  "messages": {
    "all": "Angalia ujumbe wote",
    "new": "Ujumbe mpya kutoka {name}",
    "mark_as_read": "Weka kama umesomwa"
  },
  "navbar": {
    "messageUs": "Maswali ya uendelezaji wa wavuti:",
    "repository": "Hifadhi ya GitHub"
  },
  "notifications": {
    "all": "Angalia arifa zote",
    "less": "Angalia arifa chache",
    "mark_as_read": "Weka kama imesomwa",
    "sentMessage": "amekutumia ujumbe",
    "uploadedZip": "amepakia faili mpya la Zip la {type}",
    "startedTopic": "ameanzisha mada mpya"
  },
  "user": {
    "language": "Badilisha lugha",
    "logout": "Toka",
    "profile": "Wasifu",
    "settings": "Mipangilio",
    "billing": "Bili",
    "faq": "Maswali",
    "helpAndSupport": "Msaada & ushauri",
    "projects": "Miradi",
    "account": "Akaunti",
    "explore": "Chunguza"
  },
  "treeView": {
    "basic": "Msingi",
    "icons": "Ikoni",
    "selectable": "Inayochaguliwa",
    "editable": "Inayoweza kuhaririwa",
    "advanced": "Ya juu"
  },
  "chat": {
    "title": "Mazungumzo",
    "sendButton": "Tuma"
  },
  "spacingPlayground": {
    "value": "Thamani",
    "margin": "Marjini",
    "padding": "Padigi"
  },
  "spacing": {
    "title": "Nafasi"
  },
  "helpAndSupport": "Msaada & ushauri",
  "aboutVuesticAdmin": "Kuhusu Vuestic Admin",
  "supportAndConsulting": "Msaada & Ushauri",
  "search": {
    "placeholder": "Tafuta..."
  },
  "buttonSelect": {
    "dark": "Giza",
    "light": "Mwanga"
  },
  "vuestic": {
    "search": "Tafuta",
    "noOptions": "Vipengele havikupatikana",
    "ok": "Sawa",
    "cancel": "Ghairi",
    "uploadFile": "Pakia faili",
    "undo": "Tendua",
    "dropzone": "Buruta faili hapa kupakia",
    "fileDeleted": "Faili limefutwa",
    "closeAlert": "funga arifa",
    "backToTop": "rudi juu",
    "toggleDropdown": "geuza menyu",
    "carousel": "gari ya picha",
    "close": "funga",
    "next": "Inayofuata",
    "back": "Iliyopita",
    "finish": "Maliza",
    "loading": "Inapakia"
  },
  "kicheko": {
    "tagline": "Cheka • Tazama • Piga Kura",
    "nav": {
      "home": "Nyumbani",
      "shorts": "Vipindi Fupi",
      "comedians": "Wasanii",
      "trending": "Inayovuma",
      "library": "Maktaba Yangu",
      "liked": "Zilizopendwa",
      "upload": "Pakia & Simamia",
      "studio": "Dashibodi ya Wasanii",
      "you": "Wewe",
      "studioGroup": "Studio ya Wasanii"
    },
    "sidebar": {
      "creatorPromo": {
        "question": "Je, wewe ni Mchekeshaji?",
        "pitch": "Jiunge na Kicheko, pakia vichekesho vyako na upate mapato ya kazi zako.",
        "cta": "Anza Leo"
      },
      "footer": {
        "about": "Kuhusu Sisi",
        "terms": "Vigezo",
        "privacy": "Faragha"
      }
    },
    "settings": {
      "title": "Mipangilio ya Mfumo",
      "theme": {
        "label": "Muonekano",
        "description": "Chagua muonekano wa giza au mwanga unaopendelea kutumia kwenye jukwaa la Kicheko."
      },
      "preferences": {
        "label": "Lugha na Mapendeleo",
        "description": "Weka lugha kuu ya kutumia kwenye tovuti na taarifa zako."
      },
      "notifications": {
        "label": "Mipangilio ya Taarifa",
        "description": "Chagua aina za taarifa unazotaka kupokea kuhusu video mpya, maoni na shughuli za akaunti yako."
      }
    },
    "home": {
      "hotBadge": "Inayovuma Zaidi Leo",
      "watchNow": "Tazama Sasa",
      "free": "Bure",
      "videosAvailable": "video {n} zinapatikana",
      "noVideos": "Hakuna video zilizopatikana",
      "noVideosDesc": "Hakuna video kwa kitengo hiki kwa sasa. Jaribu kuchagua \"Zote\" au tembelea kitengo kingine.",
      "showAll": "Onyesha Video Zote",
      "recommended": "Video Zinazopendekezwa",
      "freeVideos": "Video za Bure",
      "premiumVideos": "Video Maalum za Kulipia",
      "trending": "Zinazotazamwa Zaidi Tanzania",
      "comedy": "Vichekesho: {cat}",
      "shortsShelf": "Shorts za Kicheko",
      "seeAll": "Tazama zote",
      "moreVideos": "Video Nyingine"
    },
    "navbar": {
      "watchPlatform": "Tazama Jukwaa",
      "accountSettings": "Mipangilio ya Akaunti",
      "mySettings": "Mipangilio"
    },
    "admin": {
      "nav": {
        "public": "Jukwaa la Umma",
        "studio": "Studio ya Kicheko",
        "videos": "Pakia & Simamia Video",
        "users": "Wasanii & Watumiaji",
        "payments": "Malipo & Mauzo",
        "billing": "Miamala ya Mauzo",
        "paymentMethods": "Njia za Malipo",
        "pricingPlans": "Gharama za Video",
        "profile": "Wasifu wa Msanii",
        "settings": "Mipangilio ya Mfumo",
        "faq": "Msaada & Maswali"
      }
    }
  },
  "taifa": {
    "layout": {
      "kichekoPro": "Kicheko Pro",
      "naniNiNani": "Nani ni Nani?",
      "wallOfFame": "Wall of Fame",
      "login": "Ingia",
      "logout": "Toka",
      "adminStudio": "Admin Studio",
      "back": "Rudi",
      "tagline": "Yakujivunia ni tele..."
    },
    "home": {
      "question": "Je, wewe ndiye comedian ajae?",
      "yes": "Ndiyo",
      "feeNote": "Ada ya usajili (mara moja): TSh {fee} — unalipa kwa mobile money",
      "step1Title": "1. Sajili Maombi Yako",
      "step1Desc": "Weka jina lako, chuo chako na namba ya simu — bila malipo yoyote.",
      "step2Title": "2. Nani ni Nani?",
      "step2Desc": "Tazama mapambano ya wachekeshaji wa vyuo na piga kura kwa TSh 1,000 kumuinua unayempenda.",
      "step3Title": "3. Wall of Fame",
      "step3Desc": "Kutana na mabingwa wa vichekesho waliowahi kutikisa majukwaa ya vyuo Tanzania.",
      "voteTitle": "Kicheko Pro: Mwenendo wa Kura",
      "votes": "kura",
      "vote": "Piga Kura",
      "voteEmpty": "Hakuna washindani kwenye orodha ya kura bado.",
      "voteFor": "Mpigie kura {name}",
      "feePerVote": "TSh {fee} kwa kila kura",
      "payerPhone": "Namba ya simu ya malipo",
      "totalToPay": "Jumla ya kulipa",
      "payAndVote": "Lipa TSh {amount} & piga kura",
      "approveOnPhone": "Thibitisha malipo kwenye simu yako",
      "approveOnPhoneDesc": "Weka PIN kwenye ujumbe wa malipo. Kura zako zitaongezwa malipo yakithibitishwa.",
      "votesAdded": "Kura zako kwa {name} zimeongezwa — sasa ana {pct}%!",
      "voteFailed": "Malipo yameshindikana — hakuna kura iliyoongezwa.",
      "votePending": "Malipo bado yanathibitishwa. Kura zako zitaonekana yakikamilika.",
      "done": "Sawa",
      "liveLabel": "Kura zinaendelea",
      "voteSubtitle": "Usajili umefungwa — mpe sapoti mchekeshaji unayempenda.",
      "contestantsShort": "Washindani",
      "colRank": "Nafasi",
      "colComedian": "Mchekeshaji",
      "colUniversity": "Chuo",
      "colShare": "Asilimia",
      "colVotes": "Kura",
      "voteFooter": "Asilimia ya kura zote zilizolipiwa · TSh {fee} kwa kura kupitia Pay-IT"
    },
    "register": {
      "createAccount": "Tuma Maombi Sasa",
      "fillDetails": "Jaza taarifa zako kuanza safari yako ya Kicheko Pro.",
      "firstName": "Jina la Kwanza",
      "firstNamePlaceholder": "Weka jina lako la kwanza",
      "lastName": "Jina la Ukoo",
      "lastNamePlaceholder": "Weka jina lako la ukoo",
      "username": "Jina la Mtumiaji",
      "usernamePlaceholder": "Chagua jina la mtumiaji",
      "email": "Barua Pepe",
      "emailPlaceholder": "wewe{'@'}mfano.com",
      "university": "Chuo Kikuu",
      "selectUniversity": "Chagua chuo chako",
      "phone": "Namba ya Simu",
      "phoneNote": "Tutatumia namba hii kuwasiliana nawe kuhusu ombi lako.",
      "alreadyRegisteredTitle": "Tayari Umejisajili",
      "alreadyRegisteredDesc": "Namba hii ya simu au barua hii pepe tayari ina ombi la Kicheko Pro lililolipwa — huna haja ya kujisajili tena.",
      "back": "Nyuma",
      "submit": "Wasilisha",
      "confirmTitle": "Thibitisha Maombi & Lipa Ada",
      "confirmFeeDesc": "Lipa ada ya maombi ya comedian ya TSh 10,000",
      "step1Title": "1. Taarifa za Maombi",
      "step2Title": "2. Malipo (PayIt)",
      "applicant": "Mshiriki",
      "feeBoxTitle": "Kiasi cha Ada ya Usajili",
      "selectPayment": "Chagua Njia ya Malipo:",
      "payViaPayit": "Lipa TSh 10,000 kwa PayIt",
      "payInThisTab": "Au lipa kwenye ukurasa huu huu",
      "waitingPayment": "Tunasubiri uthibitisho wa malipo… Idhinisha malipo kwenye simu yako.",
      "checkStatus": "Kagua Hali ya Malipo",
      "paymentProvider": "Malipo Salama kupitia PayIt",
      "supportedNetworks": "M-Pesa · Mixx by Yas · Airtel Money · Halopesa",
      "payAndSubmit": "Lipa TSh 10,000 & Kamilisha",
      "confirming": "Inatuma...",
      "cancel": "Ghairi",
      "paymentMethod": "Njia ya Malipo",
      "mobileMoney": "Mobile Money",
      "payerPhone": "Namba ya Simu ya Malipo",
      "payerName": "Jina Kamili",
      "purpose": "Kusudi la Malipo (hiari)",
      "purposeDefault": "Kicheko Application fees",
      "payNow": "Lipa {amount}",
      "changeDetails": "Badilisha namba au taarifa",
      "promptSentTitle": "Ombi la malipo limetumwa kwenye simu yako!",
      "promptSentDesc": "Tafadhali ingiza PIN yako kwenye simu (+255 {phone}) kukamilisha malipo.",
      "invalidPhone": "Tafadhali weka namba sahihi ya simu ya tarakimu 9.",
      "orOpenPayit": "Au fungua ukurasa wa PayIt",
      "successTitle": "Hongera, Maombi Yametumwa!",
      "successDesc": "Ombi lako na malipo yamepokelewa — linasubiri idhini ya Usimamizi kabla ya kuonekana kwenye Nani ni Nani au Wall of Fame.",
      "successDescPending": "Ombi lako limesajiliwa na malipo yako yanathibitishwa — litaonekana baada ya ukaguzi wa usimamizi.",
      "paymentRef": "Kumbukumbu ya Ombi:",
      "appRef": "Kumbukumbu ya Ombi:",
      "viewNani": "Tazama Nani ni Nani?",
      "returnHome": "Rudi Nyumbani",
      "confirmingTitle": "Tunathibitisha malipo yako…",
      "confirmingDesc": "Tafadhali subiri — tunathibitisha malipo yako na mtoa huduma. Usifunge ukurasa huu.",
      "title": "Usajili wa Comedian",
      "next": "Endelea",
      "submitFailed": "Hatukuweza kuwasilisha ombi lako. Tafadhali jaribu tena.",
      "feeNotice": "Ada ya usajili: TSh {fee} — utalipa katika hatua inayofuata kupitia mobile money."
    },
    "nani": {
      "title": "Nani ni Nani?",
      "subtitle": "Tazama, linganisha na pigia kura mchekeshaji bora!",
      "roundOngoing": "Mzunguko #{round} Unaendelea",
      "votes": "Kura",
      "vote": "Piga Kura",
      "completeVote": "Kamilisha Kura Yako",
      "payVoteDesc": "TSh {fee} kwa kila kura kwa {name} — malipo salama kupitia Pay-IT.",
      "amount": "Kiasi",
      "payVoteBtn": "Lipa TSh {fee}",
      "verifyingVote": "Inathibitisha Kura...",
      "cancel": "Ghairi",
      "votedSuccess": "UmemPigia Kura {name} kwa TSh {fee}! Sasa ana {pct}% ya kura",
      "voteDoneTitle": "Kura imepokelewa!",
      "done": "Imekamilika",
      "loading": "Inapakia mashindano...",
      "endedPill": "Mzunguko #{round} • Imekwisha",
      "battleEnded": "Pambano Limekwisha",
      "battlesTitle": "Mapambano",
      "watchClip": "Tazama Video",
      "prevBattle": "Pambano lililopita",
      "nextBattle": "Pambano linalofuata",
      "ofVotes": "ya kura",
      "phonePlaceholder": "Namba ya simu ya malipo mf. 0712 345 678",
      "approveOnPhone": "Thibitisha malipo kwenye simu yako",
      "approveOnPhoneDesc": "Weka PIN kwenye ujumbe wa malipo. Kura zako zitahesabiwa malipo yakithibitishwa.",
      "voteFailed": "Malipo yameshindikana — hakuna kura iliyoongezwa.",
      "votePending": "Malipo bado yanathibitishwa. Kura zako zitaonekana yakikamilika.",
      "voteShare": "Asilimia ya kura",
      "feeNote": "TSh {fee} kwa kila kura — malipo kupitia mobile money",
      "emptyTitle": "Hakuna mashindano kwa sasa",
      "emptyDesc": "Mashindano mapya yanakuja hivi karibuni — rudi tena kupiga kura."
    },
    "payment": {
      "loading": "Inapakia malipo salama...",
      "redirecting": "Inakupeleka kwenye ukurasa wa malipo ya PayIt...",
      "loadError": "Hatukuweza kupakia fomu ya malipo.",
      "timeoutError": "Fomu ya malipo haijapakia. Unaweza kulipa kupitia ukurasa wa PayIt.",
      "startError": "Hatukuweza kufungua fomu ya malipo.",
      "successTitle": "Malipo Yamepokelewa!",
      "successDesc": "Tumepokea malipo yako. Uthibitisho unafuata baada ya malipo kukamilika.",
      "failedTitle": "Malipo Hayakukamilika",
      "failExhausted": "Majaribio yote ya malipo yameshindwa. Anza upya kujaribu tena.",
      "failExpired": "Kipindi cha malipo kimeisha kabla ya kukamilika.",
      "failCancelled": "Malipo yameghairiwa.",
      "failGeneric": "Malipo hayakukamilika.",
      "tryAgain": "Jaribu Tena",
      "openPayit": "Fungua ukurasa wa PayIt",
      "paymentRef": "Kumbukumbu ya Malipo:",
      "pageSuccessTitle": "Malipo Yamekamilika",
      "pageSuccessDesc": "Asante! Malipo yako yamepokelewa na ombi lako linasubiri uhakiki wa Usimamizi.",
      "pageFailedTitle": "Malipo Hayakukamilika",
      "pageFailedDesc": "Malipo hayakukamilika. Unaweza kujaribu tena kupitia fomu ya maombi.",
      "secureFooter": "Malipo yanashughulikiwa kwa usalama na PayIt. Kiasi ni kwa TSh.",
      "payerPhoneLabel": "Namba ya Mobile Money",
      "payerPhonePlaceholder": "712 345 678",
      "initiating": "Inatuma ombi la malipo…",
      "initiateError": "Imeshindwa kutuma ombi la malipo. Jaribu tena.",
      "promptSent": "Ombi la malipo limetumwa — angalia simu yako na uidhinishie ombi kukamilisha.",
      "done": "Imekamilika",
      "instructions": "Bonyeza kulipa na ombi salama litatumwa kwenye simu yako — liidhinishie kwa PIN yako ya mobile money kukamilisha malipo.",
      "stepSent": "Ombi la malipo limetumwa kwenye simu yako",
      "stepApprove": "Idhinisha ombi kwa PIN yako",
      "stepConfirm": "Inathibitisha malipo yako",
      "notReceived": "Hujapokea ombi? Rudi nyuma",
      "pendingTitle": "Kamilisha malipo yako ya usajili",
      "pendingDesc": "Una malipo ya usajili ambayo hayajakamilika — yakamilishe ili kuwasilisha ombi lako.",
      "resumeBtn": "Kamilisha Malipo",
      "payLater": "Lipa baadaye"
    },
    "wall": {
      "title": "WALL OF FAME",
      "byTaifa": "na Taifa House",
      "home": "Nyumbani",
      "searchPlaceholder": "Tafuta makala...",
      "categories": {
        "campuslife": "Maisha ya Chuo",
        "fursamafanikio": "Fursa & Mafanikio",
        "teknolojia": "Teknolojia",
        "burudani": "Burudani",
        "maishayachuo": "Hadithi za Wanafunzi",
        "maishayakijamii": "Maisha ya Kijamii"
      },
      "advertise": {
        "kicker": "Matangazo",
        "title": "Tangaza nasi",
        "sub": "Fikia maelfu ya wanafunzi",
        "cta": "Jifunze zaidi"
      },
      "trending": "Makala Yanayovuma",
      "minRead": "Dakika {min} kusoma",
      "likesShort": "penda",
      "commentsShort": "maoni",
      "share": "Share",
      "save": "Hifadhi",
      "backToFeed": "Rudi kwenye makala",
      "comments": "Maoni ({count})",
      "commentInput": "Andika maoni yako...",
      "commentsSoon": "Maoni yanakuja hivi karibuni — huduma ya maoni inaunganishwa.",
      "emptyFeed": "Hakuna makala bado",
      "emptyFeedDesc": "Hadithi mpya zinakuja hivi karibuni.",
      "commentsRefresh": "Sasisha",
      "commentsEmpty": "Hakuna maoni bado — kuwa wa kwanza!",
      "commentName": "Jina lako",
      "commentFailed": "Imeshindwa kutuma maoni yako. Jaribu tena.",
      "justNow": "sasa hivi",
      "minsAgo": "dak {n} zilizopita",
      "hoursAgo": "saa {n} zilizopita",
      "daysAgo": "siku {n} zilizopita",
      "loginToComment": "Ingia kutoa maoni",
      "loginToCommentDesc": "Lazima uingie kwanza ili kutoa maoni.",
      "copyLink": "Nakili kiungo",
      "editComment": "Hariri",
      "deleteComment": "Futa",
      "saveComment": "Hifadhi",
      "cancelEdit": "Ghairi",
      "edited": "(imehaririwa)",
      "deleteCommentConfirm": "Futa maoni haya?",
      "commentUpdateFailed": "Imeshindikana kuhariri maoni.",
      "commentDeleteFailed": "Imeshindikana kufuta maoni."
    },
    "admin": {
      "title": "Dashibodi Kuu ya Usimamizi",
      "subtitle": "Usimamizi wa maombi ya wachekeshaji, ada ya usajili, mapambano ya Nani ni Nani na Wall of Fame.",
      "applicationsTitle": "Maombi ya Wachekeshaji",
      "batches": {
        "nav": "Vikundi vya Kura",
        "title": "Vikundi vya Kura",
        "subtitle": "Panga wachekeshaji walioidhinishwa katika raundi za kura na wapandishe washindi kwenda kiwango kinachofuata.",
        "titleLabel": "Jina la kundi",
        "titlePlaceholder": "mf. Mchekeshaji wa IFM",
        "levelLabel": "Kiwango",
        "levelValue": "Kiwango cha {level}",
        "create": "Tengeneza kundi",
        "selectBatch": "Chagua kundi",
        "newOption": "+ Kundi jipya…",
        "newBatchTitle": "Jina la kundi jipya",
        "newBatchTitlePlaceholder": "Jina la shindano",
        "newBatchLevel": "Kiwango cha kundi jipya",
        "addToBatch": "Ongeza kwenye kundi",
        "adding": "Inaongezwa…",
        "filterAll": "Vikundi vyote",
        "filterNone": "Hakuna kundi",
        "filterLabel": "Chuja kwa kundi",
        "openSuffix": "● Wazi",
        "openVotingNowConfirm": "Ungependa kufungua kura kwa kundi “{title}” sasa? Kundi hili litaonekana kwenye Kicheko Pro.",
        "noBatchVoteList": "Hakuna kundi – hayupo kwenye orodha ya kura",
        "levelChangeConfirm": "Kubadilisha kiwango kutamwondoa mwombaji huyu kwenye kundi “{title}”. Unaendelea?",
        "empty": "Bado hakuna vikundi vya kura. Tengeneza kundi la kwanza hapo juu.",
        "error": "Mabadiliko hayajahifadhiwa. Tafadhali jaribu tena.",
        "applicantCount": "Waombaji {count}",
        "openVoting": "Fungua kura",
        "closeVoting": "Funga kura",
        "delete": "Futa",
        "deleteConfirm": "Ufute “{title}”? Waombaji wake watarudishwa kiwango cha 1.",
        "selectApplicant": "Chagua mwombaji",
        "applicant": "Mchekeshaji",
        "university": "Chuo Kikuu",
        "votes": "Kura",
        "noApplicants": "Hakuna waombaji kwenye kundi hili.",
        "removeSelected": "Ondoa waliochaguliwa",
        "promoteTo": "Pandisha waliochaguliwa kwenda…",
        "promote": "Pandisha",
        "addApplicants": "Ongeza waombaji walioidhinishwa",
        "currentBatch": "Yupo kwenye {title}",
        "noAvailableApplicants": "Hakuna waombaji wengine walioidhinishwa wa kuongeza.",
        "addSelected": "Ongeza waliochaguliwa",
        "skipped": "Waombaji {count} wamerukwa kwa kuwa hawajaidhinishwa.",
        "batchColumn": "Kundi la sasa",
        "selectedCount": "{count} wamechaguliwa"
      },
      "universitiesNav": "Vyuo Vikuu",
      "totalApps": "Jumla ya Maombi",
      "pendingApproval": "Yanasubiri Idhini",
      "confirmedApps": "Yaliyothibitishwa",
      "feeRevenue": "Mapato ya Ada ya Usajili",
      "all": "Maombi Yote",
      "filterPending": "Yanasubiri Idhini",
      "filterApproved": "Yaliyoidhinishwa",
      "filterUnpaid": "Bado Hayajalipwa",
      "filterRejected": "Yaliyokataliwa",
      "searchPlaceholder": "Tafuta jina, chuo, simu...",
      "applicantTh": "Mchekeshaji",
      "universityTh": "Chuo Kikuu",
      "phoneTh": "Simu & Tarehe",
      "feeTh": "Ada ya Usajili",
      "statusTh": "Hali ya Ombi",
      "actionsTh": "Vitendo",
      "approveBtn": "Thibitisha",
      "rejectBtn": "Kataa",
      "paidStatus": "TSh 10,000 Imelipwa",
      "unpaidStatus": "Bado Haijalipwa",
      "markPaid": "Weka Imelipwa",
      "refreshBtn": "Onyesha Upya",
      "deleteBtn": "Futa Ombi",
      "deleteConfirm": "Una uhakika unataka kufuta ombi hili?",
      "editBtn": "Hariri",
      "deleteLabel": "Futa",
      "cancelBtn": "Ghairi",
      "feeBadge": "Usajili: Bure",
      "totalAppsDesc": "Wanafunzi waliojisajili",
      "pendingPaidDesc": "Wamelipa, wanasubiri ukaguzi",
      "confirmedDesc": "Wachekeshaji Rasmi",
      "feeRevenueTitle": "Mapato ya Ada (kiasi kilichopokelewa)",
      "feeRevenueDesc": "Kupitia M-Pesa / Tigo / Airtel",
      "feePaidLabel": "TSh {amount} (Imelipwa)",
      "feeUnderpaidLabel": "TSh {amount} kati ya {fee} (Pungufu)",
      "feeProcessingLabel": "Inachakatwa",
      "feePendingLabel": "Haijalipwa",
      "statusPendingAdmin": "Inasubiri Idhini ya Admin",
      "statusPendingFee": "Inasubiri Ada ya Usajili",
      "statusRejected": "Imekataliwa",
      "emptyTitle": "Hakuna maombi yaliyopatikana",
      "emptyDesc": "Hakuna kumbukumbu kulingana na kichujio chako.",
      "universities": {
        "title": "Usimamizi wa Vyuo Vikuu",
        "count": "Vyuo {count}",
        "subtitle": "Dhibiti orodha ya vyuo vikuu vinavyoshiriki mashindano na kuonekana kwenye fomu ya kujiunga ya Kicheko Pro.",
        "addBtn": "Ongeza Chuo Kipya",
        "statusActive": "Inatumika",
        "statusInactive": "Imezimwa",
        "editTitle": "Hariri Chuo Kikuu",
        "addTitle": "Ongeza Chuo Kikuu Kipya",
        "nameLabel": "Jina Kamili la Chuo",
        "namePlaceholder": "mf. Chuo Kikuu cha Dar es Salaam",
        "codeLabel": "Kifupisho (Code)",
        "codePlaceholder": "mf. UDSM",
        "locationLabel": "Mkoa / Eneo",
        "locationPlaceholder": "mf. Dar es Salaam",
        "badgeLabel": "Njia ya Nembo (Badge Image Path)",
        "activeLabel": "Chuo hiki kiko hai kwa ajili ya usajili",
        "savingBtn": "Inahifadhi...",
        "saveBtn": "Hifadhi Chuo",
        "deleteConfirm": "Una uhakika unataka kufuta chuo hiki?"
      },
      "manageFame": {
        "title": "Makala ya Wall of Fame",
        "count": "Makala {count}",
        "subtitle": "Chapisha na dhibiti makala yanayoonekana kwenye Wall of Fame.",
        "viewBtn": "Tazama",
        "addBtn": "Ongeza Makala",
        "deleteTitle": "Futa Makala",
        "editTitle": "Hariri Makala",
        "addTitle": "Ongeza Makala Jipya",
        "titleLabel": "Kichwa",
        "categoryLabel": "Kategoria",
        "excerptLabel": "Muhtasari mfupi",
        "bodyLabel": "Mwili wa makala",
        "readTimeLabel": "Muda wa kusoma (dak)",
        "imageLabel": "Picha ya jalada",
        "saveBtn": "Hifadhi Makala",
        "deleteConfirm": "Una uhakika unataka kufuta makala haya?"
      },
      "nani": {
        "title": "Usimamizi wa \"Nani ni Nani?\"",
        "subtitle": "Panga mapambano ya wachekeshaji wa vyuo, fuatilia kura na ada ya TSh 1,000 kwa kila kura.",
        "viewBtn": "Tazama Jukwaani",
        "resetBtn": "Weka Upya",
        "totalVotesLabel": "Jumla ya Kura Zilizopigwa",
        "totalVotesDesc": "Kura zote kwenye pambano hai",
        "revenueLabel": "Mapato ya Kura (TSh 1,000 / Kura)",
        "revenueDesc": "Mapato ya wapiga kura Tanzania",
        "leaderLabel": "Mchekeshaji Anayeongoza",
        "tie": "Sare",
        "votesText": "kura {votes}",
        "contestantATitle": "Mshiriki A (Upande wa Kushoto)",
        "contestantBTitle": "Mshiriki B (Upande wa Kulia)",
        "votesBadge": "{votes} Kura ({pct}%)",
        "nameLabel": "Jina Kamili",
        "codeLabel": "Kifupi cha Chuo",
        "initialVotesLabel": "Idadi ya Kura za Awali",
        "saveBtn": "Hifadhi Mabadiliko ya Washiriki",
        "savedMsg": "Mabadiliko yamehifadhiwa!",
        "resetVotesBtn": "Weka Kura Zote Kuwa 0",
        "resetVotesConfirm": "Una uhakika unataka kuweka kura zote kuwa sifuri (0)?",
        "battlesCount": "Mapambano {count}",
        "newBattleBtn": "Pambano Jipya",
        "newBattleTitle": "Tengeneza Pambano Jipya",
        "editBattleTitle": "Hariri Pambano",
        "titleLabel": "Kichwa cha Pambano",
        "roundLabel": "Raundi",
        "feeLabel": "Ada ya Kura (TSh)",
        "categoryLabel": "Aina ya Burudani",
        "categoryNone": "Hakuna Aina",
        "statusLabel": "Hali",
        "statusDraft": "Rasimu",
        "statusActive": "Inaendelea",
        "statusEnded": "Imekwisha",
        "badgeLabel": "Nembo ya Chuo",
        "videoUrlLabel": "Kiungo cha Video (YouTube)",
        "activateBtn": "Wezesha",
        "emptyBattles": "Hakuna mapambano bado — tengeneza pambano jipya.",
        "deleteBattleConfirm": "Una uhakika unataka kufuta pambano hili?",
        "themeColorLabel": "Rangi ya Pambano",
        "feeFixed": "Bei ya kura ni TSh 1,000 (haibadiliki)",
        "colBattle": "Pambano",
        "colContestantA": "Mshiriki A",
        "colContestantB": "Mshiriki B"
      },
      "videos": {
        "title": "Usimamizi na Upakiaji wa Video za Kicheko",
        "subtitle": "Pakia video mpya za vichekesho, tengeneza preview fupi za Shorts, weka bei na dhibiti maudhui.",
        "uploadBtn": "Pakia Video Mpya",
        "statTotal": "Jumla ya Video",
        "statPaid": "Video za Kulipia",
        "statShorts": "Shorts / Previews",
        "statViews": "Jumla ya Views",
        "tableTitle": "Orodha ya Video zilizopo Kwenye Mfumo",
        "videoCount": "video {count}",
        "thVideo": "Video / Kichwa",
        "thArtist": "Msanii",
        "thCategory": "Kitengo",
        "thAccess": "Aina ya Upatikanaji",
        "thViews": "Views",
        "durationLabel": "Muda: {duration}",
        "paidBadge": "Kulipia: Tsh {price}",
        "viewLink": "Tazama",
        "modalTitle": "Pakia Video Mpya ya Kicheko",
        "titleLabel": "Kichwa cha Video (Title) *",
        "titlePlaceholder": "Mfano: Cheka Tu Live: Vituko vya Dar es Salaam...",
        "descLabel": "Maelezo ya Video (Description)",
        "descPlaceholder": "Eleza kwa ufupi maudhui ya onyesho hili la vichekesho...",
        "comedianLabel": "Msanii / Mchekeshaji (Comedian) *",
        "categoryLabel": "Kitengo (Category) *",
        "accessLabel": "Upatikanaji (Access Type)",
        "accessFree": "Bure (Free)",
        "accessPaid": "Kulipia (Paid)",
        "priceLabel": "Bei ya Video (TZS) *",
        "videoUrlLabel": "URL ya Faili la Video (mp4 / webm)",
        "thumbUrlLabel": "URL ya Picha ya Jalada (Thumbnail)",
        "shortLabel": "Hii ni Short Preview (Video fupi ya 9:16 ya kuunganisha na video kuu)",
        "cancelBtn": "Ghairi (Cancel)",
        "submittingBtn": "Inapakia...",
        "submitBtn": "Chapisha Video Sasa",
        "uploadSuccess": "Video imepakiwa na kuchapishwa kikamilifu!"
      },
      "applicationsOpenBtn": "Usajili: Wazi",
      "applicationsClosedBtn": "Usajili: Imefungwa",
      "levelTh": "Kiwango",
      "levelLabel": "Kiwango {n}",
      "onVoteList": "Anaonekana kwenye orodha ya kura",
      "notOnVoteList": "Bado hayupo kwenye orodha ya kura",
      "flowHint": "Mtiririko: mwombaji analipa (au unaweka malipo kuwa yamelipwa) → Idhinisha → funga maombi → chagua waombaji walioidhinishwa na ubonyeze “Ongeza kwenye kundi” (jina la shindano + kiwango cha 2–4) → fungua kura kwa kundi hilo kwenye ukurasa wa Vikundi vya Kura ili lionekane Kicheko Pro.",
      "bulkSelected": "{n} wamechaguliwa",
      "bulkHint": "Walioidhinishwa tu — wengine wanarukwa.",
      "bulkApply": "Weka kiwango",
      "bulkUpdating": "Inasasisha…",
      "bulkClear": "Futa",
      "bulkSelectAll": "Chagua wote walioidhinishwa",
      "levelNeedsApproval": "Idhinisha ombi kwanza — viwango vinatumika kwa walioidhinishwa tu.",
      "bulkSkipped": "Maombi {n} yamerukwa kwa sababu hayakuwa yameidhinishwa.",
      "voteFeeLabel": "Bei ya kura (TSh)",
      "appFeeLabel": "Ada ya maombi (TSh)",
      "saveBtn": "Hifadhi"
    },
    "voteStats": {
      "nav": "Takwimu za Kura",
      "title": "Takwimu za Kura",
      "subtitle": "Ununuzi wote wa kura — Kicheko Pro na Nani ni Nani",
      "tabKicheko": "Kicheko Pro",
      "tabNani": "Nani ni Nani",
      "purchases": "Manunuzi",
      "purchasesDesc": "Jaribio zote za kulipa",
      "confirmed": "Yaliyothibitishwa",
      "confirmedDesc": "Malipo yaliyokamilika",
      "votesCast": "Kura",
      "votesCastDesc": "Kura zilizothibitishwa",
      "revenue": "Mapato",
      "revenueDesc": "TSh zilizokusanywa",
      "leaderboard": "Ubao wa Kura",
      "recentPurchases": "Manunuzi ya Hivi Karibuni",
      "colVotedFor": "Aliyepigiwa",
      "colVotes": "Kura",
      "colAmount": "Kiasi",
      "colStatus": "Hali",
      "colPhone": "Simu",
      "colTime": "Muda",
      "statusPaid": "Imelipwa",
      "statusPending": "Inasubiri",
      "statusFailed": "Imeshindwa",
      "empty": "Hakuna kura bado",
      "justNow": "sasa hivi",
      "updatedAt": "Imesasishwa {time}"
    },
    "dashboard": {
      "liveOnline": "Live Mtandaoni",
      "viewPlatform": "Tazama Jukwaa",
      "reviewApps": "Kagua Maombi",
      "appsCard": "Maombi ya Wachekeshaji",
      "approved": "Yaliyoidhinishwa",
      "newApps": "mapya",
      "feeCard": "Ada za Usajili",
      "feeFrom": "Kutoka kwa wachekeshaji",
      "naniVotesCard": "Kura za \"Nani ni Nani?\"",
      "revenue": "Mapato",
      "perVote": "(1,000 TSh / Kura)",
      "fameCard": "Wall of Fame",
      "fameApproved": "Mabingwa walioidhinishwa rasmi",
      "activeBattle": "Pambano Linaloendelea Sasa: \"Nani ni Nani?\"",
      "voteFeeNote": "Watazamaji wanapiga kura kwa TSh 1,000",
      "manageBattle": "Dhibiti Pambano",
      "recentApps": "Maombi ya Hivi Karibuni ya Wachekeshaji",
      "recentAppsDesc": "Wachekeshaji waliojisajili hivi karibuni",
      "viewAll": "Tazama Yote",
      "applicantTh": "Mchekeshaji",
      "universityTh": "Chuo Kikuu",
      "feeTh": "Ada (TSh)",
      "statusTh": "Hali",
      "actionsTh": "Kitendo",
      "paid": "Imelipwa",
      "unpaid": "Bado",
      "statusApproved": "Imethibitishwa",
      "statusPendingReview": "Inasubiri Idhini",
      "approveBtn": "Thibitisha",
      "complete": "Kamilifu"
    },
    "pages": {
      "common": {
        "followers": "{count} wafuasi",
        "views": "matazamo {count}",
        "follow": "Mfuatilie (Follow)",
        "following": "Unamfuata",
        "share": "Shiriki",
        "followedToast": "Sasa unamfuata {name}!",
        "unfollowedToast": "Umeacha kumfuata {name}."
      },
      "comedians": {
        "title": "Wasanii wa Kicheko Tanzania",
        "subtitle": "Gundua wachekeshaji maarufu na wanaochipukia, tazama kazi zao na uwafuate.",
        "verified": "Imethibitishwa",
        "viewWork": "Tazama kazi"
      },
      "profile": {
        "videosCount": "video {count}",
        "allVideos": "Video Zote ({count})",
        "shortsTab": "Shorts ({count})",
        "noVideos": "Msanii huyu bado hajapakia video ndefu.",
        "noShorts": "Msanii huyu hana Shorts kwa sasa."
      },
      "search": {
        "resultsFor": "Matokeo ya utafutaji wa:",
        "videosFound": "Video {count} zimepatikana",
        "placeholder": "Tafuta jina la video au msanii...",
        "noResults": "Hakuna matokeo yaliyopatikana",
        "noResultsHint": "Jaribu maneno mengine kama \"Joti\", \"Cheka Tu\", \"Mpoki\", au \"Skits\"."
      },
      "shorts": {
        "counter": "{current} ya {total}",
        "nextTitle": "Short Inayofuata",
        "next": "Ijayo",
        "watchFull": "Tazama Onyesho Lote (Watch Full Video)",
        "empty": "Hakuna video fupi (Shorts) kwa sasa.",
        "likedToast": "Umependa Short hii!",
        "linkCopied": "Kiungo cha Short kimewekwa kwenye clipboard!"
      },
      "watch": {
        "buy": "Nunua",
        "share": "Shiriki (Share)",
        "upNext": "Inayofuata (Up Next)",
        "paid": "Ya Kulipia",
        "showMore": "Soma zaidi (Show more)",
        "showLess": "Funga (Show less)",
        "paymentTitle": "Malipo ya Video ya Kicheko",
        "buyAccess": "Nunua haki ya kutazama:",
        "amountDue": "Kiasi cha Kulipa:",
        "phoneLabel": "Namba ya Simu ya Kutoa Pesa:",
        "phonePlaceholder": "07XXXXXXXX au +255...",
        "verifying": "Inathibitisha...",
        "payNow": "Lipia Sasa",
        "loading": "Inapakia video...",
        "likedToast": "Umependa video hii!",
        "linkCopied": "Kiungo cha video kimewekwa kwenye clipboard!"
      },
      "library": {
        "title": "Maktaba Yangu ya Kicheko",
        "subtitle": "Hapa unakuta video ulizonunua na zile ulizoweka alama ya kupenda.",
        "purchasedTab": "Video Zilizolipwa ({count})",
        "likedTab": "Zilizopendwa ({count})",
        "noPurchased": "Bado hujanunua video yoyote",
        "noPurchasedDesc": "Unaponunua video za kulipia za wasanii wako pendwa, zitaonekana hapa moja kwa moja bila kikomo cha kuzitazama.",
        "browseCta": "Tazama Video za Sasa",
        "noLiked": "Bado huna video ulizozipenda",
        "noLikedDesc": "Bonyeza kitufe cha 'Like' kwenye video yoyote ya Kicheko ili kuihifadhi hapa."
      },
      "fame": {
        "loading": "Inapakia Wall of Fame...",
        "emptyTitle": "Hakuna Mabingwa Bado",
        "emptyDesc": "Mabingwa wa Kicheko Pro wataorodheshwa hapa hivi karibuni."
      },
      "pro": {
        "logoAlt": "Kicheko Pro - Jiandae Kucheka"
      },
      "register": {
        "paymentAlt": "Malipo"
      },
      "nani": {
        "cardOption": "Kadi ya Benki",
        "cardsAlt": "Kadi"
      }
    },
    "misc": {
      "common": {
        "name": "Jina",
        "save": "Hifadhi",
        "edit": "Hariri",
        "delete": "Futa",
        "search": "Tafuta",
        "status": "Hali",
        "team": "Timu",
        "export": "Hamisha",
        "today": "Leo",
        "week": "Wiki",
        "month": "Mwezi",
        "noProjects": "Hakuna miradi"
      },
      "users": {
        "active": "Hai",
        "inactive": "Haiko Hai",
        "addUser": "Ongeza Mtumiaji",
        "editUser": "Hariri mtumiaji",
        "add": "Ongeza",
        "userUpdated": "{name} amesasishwa",
        "userCreated": "{name} ameundwa",
        "userDeleted": "{name} amefutwa",
        "unsavedChanges": "Fomu ina mabadiliko yasiyohifadhiwa. Una uhakika unataka kuifunga?",
        "addImage": "Ongeza picha",
        "fullName": "Jina Kamili",
        "role": "Jukumu",
        "roleAdmin": "Msimamizi",
        "roleUser": "Mtumiaji",
        "roleOwner": "Mmiliki",
        "notes": "Maelezo",
        "deleteUser": "Futa mtumiaji",
        "deleteConfirm": "Una uhakika unataka kumfuta {name}?",
        "moreProjects": "{names} + {count} zaidi",
        "results": "Matokeo {n}.",
        "resultsPerPage": "Matokeo kwa ukurasa",
        "prevPage": "Ukurasa uliopita",
        "nextPage": "Ukurasa unaofuata"
      },
      "preferences": {
        "nameChanged": "Umebadilisha jina lako kwa mafanikio",
        "oldPassword": "Neno la siri la zamani",
        "newPassword": "Neno la siri jipya",
        "repeatNewPassword": "Rudia neno la siri jipya",
        "min8Chars": "Lazima liwe na angalau herufi 8",
        "unique6Chars": "Lazima liwe na angalau herufi 6 tofauti",
        "updatePassword": "Sasisha Neno la Siri",
        "passwordChanged": "Umebadilisha neno lako la siri kwa mafanikio",
        "oldPasswordRequired": "Neno la siri la zamani linahitajika",
        "newPasswordRequired": "Neno la siri jipya linahitajika",
        "passwordSame": "Neno la siri jipya haliwezi kuwa sawa na la zamani",
        "repeatPasswordRequired": "Rudia neno la siri jipya linahitajika",
        "passwordMismatch": "Neno la siri la kuthibitisha halilingani na jipya",
        "memberSince": "Mwanachama tangu",
        "twoFA": "Uthibitishaji wa hatua mbili",
        "twoFASetup": "Washa 2FA",
        "twoFADisable": "Zima 2FA",
        "twoFAEnabledDesc": "Uthibitishaji wa Hatua Mbili (2FA) umewashwa kwenye akaunti yako, ukiongeza usalama zaidi unapoingia.",
        "twoFADisabledDesc": "Ongeza usalama zaidi kwenye akaunti yako. Ili kuingia, utahitaji kutoa msimbo pamoja na jina la mtumiaji na neno la siri.",
        "twoFAEnabled": "2FA imewashwa kwa mafanikio",
        "twoFADisabled": "2FA imezimwa kwa mafanikio",
        "emailSubscriptions": "Usajili wa barua pepe",
        "manageEmails": "Ili kudhibiti barua pepe unazopokea, tembelea",
        "nameChangeFailed": "Imeshindwa kubadilisha jina. Tafadhali jaribu tena."
      },
      "faq": {
        "title": "Tunawezaje kukusaidia?",
        "noMatches": "Hakuna matokeo yaliyopatikana. Jaribu kuboresha utafutaji wako au vinjari makundi kupata msaada unaohitaji.",
        "popularQuestions": "Maswali maarufu",
        "q1Title": "Ninawezaje kupakia upya ukurasa?",
        "q1Intro": "Jiandae kwa hekima za kupakia upya kurasa! Tuko karibu kuzama katika ulimwengu wa kupakia upya kurasa za wavuti. Hizi hapa mbinu chache:",
        "q1Step1": "Bonyeza kitufe cha F5 au Ctrl + R (Windows/Linux) au Command + R (Mac) kupakia upya ukurasa wa sasa mwenyewe.",
        "q1Step2": "Bofya kitufe cha kupakia upya kwenye kivinjari chako. Huwa kinaonekana kama mshale wa duara na mara nyingi kiko kwenye upau wa anwani.",
        "q1Step3": "Tumia JavaScript kupakia upya ukurasa kwa programu: location.reload();",
        "q2Title": "Ufunguo wa Usalama ni nini?",
        "q2P1": "Ufunguo wa Usalama ni safu ya ziada ya usalama inayokulinda wewe na pesa zako kwa kutengeneza msimbo wa kipekee wa usalama unaotumika mara moja kila unapoingia au kuidhinisha malipo. Kuna aina mbili za Ufunguo wa Usalama - toleo la Kidijitali linalofanya kazi kama sehemu ya Programu ya Benki ya Simu - bora ikiwa una simu mahiri au kompyuta kibao. Au, unaweza kutumia toleo la Kimwili ambalo ni kipande kidogo cha ufunguo kama kikokotoo kidogo.",
        "q2P2": "Tunapendekeza kuweka Ufunguo wa Usalama wa Kidijitali. Umejengwa ndani ya programu ya kwanza ya moja kwa moja ya benki, na ikiwa una aina sahihi ya simu mahiri unaweza kutumia alama za kidole au utambuzi wa uso kuingia au kuidhinisha malipo kwa urahisi.",
        "q2Link": "Jua zaidi kuhusu Ufunguo wa Usalama",
        "q3Title": "Ninawezaje kuripoti ulaghai?",
        "q3P1": "Kuripoti ulaghai ni jambo la maana, na ni muhimu kuchukua hatua zinazofaa kushughulikia na kuzuia shughuli za ulaghai. Mchakato mahususi wa kuripoti ulaghai unaweza kutofautiana kulingana na eneo lako na aina ya ulaghai, lakini hapa kuna mwongozo wa jumla:",
        "q3Li1Bold": "Ripoti kwa Mamlaka Husika:",
        "q3Li1Text": "Kulingana na aina ya ulaghai, huenda ukahitaji kuripoti kwa mamlaka nyingine husika, kama Tume ya Usalama na Ubadilishaji (SEC) kwa ulaghai unaohusiana na uwekezaji au Shirika la Biashara Bora (BBB) kwa matapeli na mienendo ya udanganyifu.",
        "q3Li2Bold": "Andika Maelezo Yote:",
        "q3Li2Text": "Hakikisha unaandika maelezo yote muhimu kuhusu ulaghai, ikijumuisha tarehe, nyakati, majina ya watu wanaohusika (ikipatikana), miamala ya fedha, na mawasiliano yoyote yanayohusiana na ulaghai.",
        "q3Li3Bold": "Ripoti kwa Mashirika ya Uhalifu wa Mtandaoni:",
        "q3Li3Text": "Ikiwa ulaghai unahusisha shughuli za mtandaoni, zingatia kuripoti kwa mashirika yanayoshughulikia uhalifu wa mtandaoni, kama vile Kituo cha Malalamiko ya Uhalifu wa Mtandaoni (IC3). IC3 ni ushirikiano kati ya FBI na Kituo cha Taifa cha Uhalifu wa Kola Nyeupe.",
        "q3P2": "Kumbuka kutenda haraka na kufuata taratibu maalum za kuripoti zinazofaa eneo lako na aina ya ulaghai uliokutana nao. Kuchukua hatua za haraka kunaweza kusaidia kupunguza uharara unaoweza kutokea na kuzuia shughuli zaidi za ulaghai.",
        "q4Title": "Ninawezaje kupakua taarifa?",
        "q4P1": "Kupakua taarifa kunaweza kutofautiana kulingana na aina ya taarifa unazorejelea (k.m., taarifa za benki, taarifa za kadi ya mkopo, taarifa za huduma). Hapa chini kuna hatua za jumla za kupakua taarifa kutoka majukwaa mbalimbali:",
        "q4Li1Bold": "Hakikisha Muunganiko Salama:",
        "q4Li1Text": "Daima fikia na pakua taarifa kutoka mtandao salama na unaotuminiwa kulinda taarifa zako nyeti za kifedha.",
        "q4Li2Bold": "Kagua Taarifa Mara Kwa Mara:",
        "q4Li2Text": "Kagua taarifa zako mara kwa mara kuthibitisha miamala, kubaini makosa, au kutambua shughuli yoyote ya mashaka haraka.",
        "q4Li3Bold": "Thibitisha Maelezo ya Akaunti:",
        "q4Li3Text": "Hakikisha kwamba taarifa unazopakua zinahusiana na akaunti sahihi, ikijumuisha namba za akaunti na majina ya akaunti.",
        "q4Li4Bold": "Tumia Njia Rasmi:",
        "q4Li4Text": "Pakua taarifa tu kutoka majukwaa rasmi na yaliyoidhinishwa, kama tovuti rasmi ya benki yako au milango salama ya mtandaoni ya watoa huduma.",
        "q4P2": "Daima hakikisha unafuata hatua na maagizo maalum yaliyotolewa na mtoa huduma husika kupakua taarifa kwa usalama na usahihi. Ikiwa utakutana na ugumu wowote au una maswali mahususi, zingatia kuwasiliana na huduma kwa wateja ya taasisi au huduma husika.",
        "gotQuestions": "Una maswali?",
        "demoPitch": "Omba demo ya bure ili maswali yako yote yajibiwe na mtaalamu.",
        "requestDemo": "Omba demo",
        "sendMessageAlt": "Tuma ujumbe",
        "requestFreeDemo": "Omba demo ya bure",
        "demoModalPitch": "Weka nafasi yako sasa na washa uvumbuzi kwa suluhisho letu bora la programu! 🔥",
        "emailRequired": "Barua pepe inahitajika",
        "emailInvalid": "Barua pepe iwe sahihi",
        "demoSubmittedTitle": "Ombi la Demo Limetumwa!",
        "demoSubmittedMsg": "Mtaalamu atawasiliana nawe hivi karibuni"
      },
      "notFound": {
        "title": "Ukurasa haupatikani",
        "message": "Ukurasa unaoutafuta huenda umefutwa, jina lake likabadilishwa, au haupatikani kwa muda.",
        "goHome": "Nenda ukurasa wa nyumbani",
        "githubIssue": "Fungua suala la GitHub"
      },
      "studio": {
        "totalVideos": "Jumla ya Video",
        "thisMonth": "mwezi huu",
        "videosSplit": "{long} ndefu • {short} shorts",
        "totalViews": "Watazamaji Wote (Views)",
        "growth": "ukuaji",
        "avgPerVideo": "Wastani {n}/video",
        "revenueLabel": "Mapato ya Maudhui (TZS)",
        "sales": "mauzo",
        "likesEngagement": "Vipendwa & Ushiriki",
        "engagement": "ushiriki",
        "comedians": "{n} wachekeshaji"
      },
      "activity": {
        "title": "Shughuli za Jukwaa (Live Activity)",
        "subtitle": "Matukio na miamala ya hivi punde kwenye Kicheko",
        "live": "Moja kwa Moja",
        "cdnStatus": "Hali ya Seva ya Video (Streaming CDN):",
        "cdnHealthy": "100% Imara (Kawaida)",
        "act1Title": "Malipo ya M-Pesa Yamethibitishwa",
        "act1Desc": "Mtumiaji +255 754 *** amekamilisha Tsh 2,500 kwa video \"Cheka Tu Live Season 4\".",
        "act1Time": "Dakika 3 zilizopita",
        "act2Title": "Short Mpya Imepakiwa",
        "act2Desc": "Joti amechapisha video fupi ya Short: \"Ushauri wa Mtaa\".",
        "act2Time": "Dakika 18 zilizopita",
        "act3Title": "Milestone ya Watazamaji",
        "act3Desc": "Video ya \"Vituko vya Kariakoo\" imevuka watazamaji 850,000 leo!",
        "act3Time": "Saa 1 lililopita",
        "act4Title": "Malipo ya Tigo Pesa Yamethibitishwa",
        "act4Desc": "Mtumiaji +255 713 *** amekamilisha Tsh 1,500 kwa video \"Harusi ya Shoki\".",
        "act4Time": "Saa 2 zilizopita",
        "act5Title": "Mchekeshaji Mpya Amejiunga",
        "act5Desc": "Mau Fundi amethibitishwa rasmi na akaunti yake imewashwa kwenye Kicheko.",
        "act5Time": "Saa 4 zilizopita"
      },
      "revenue": {
        "mobileMoney": "Malipo ya Simu (Mobile Money)",
        "subtitle": "Mgawanyo wa mapato kwa watoa huduma Tanzania",
        "successRate": "{n}% Yamefanikiwa",
        "transactions": "{n} miamala",
        "ofRevenue": "{n}% ya mapato",
        "settlement": "Malipo huwekwa moja kwa moja:",
        "settlementFreq": "Kila Ijumaa (Weekly)",
        "tooltipRevenue": "{label}: {n}% ya mapato"
      },
      "leaderboard": {
        "title": "Wachekeshaji Wanaoongoza",
        "subtitle": "Wasanii nguli wenye ushawishi mkubwa zaidi jukwaani",
        "followers": "wafuasi",
        "addArtist": "Unataka kuongeza msanii mpya?",
        "uploadContent": "Pakia Maudhui Yake"
      },
      "topVideos": {
        "title": "Video Zinazoongoza kwa Utazamaji (Top Content)",
        "subtitle": "Maudhui yanayoongoza kwa watazamaji na mapato jukwaani",
        "manageAll": "Simamia Video Zote",
        "thVideo": "Video / Maudhui",
        "thArtist": "Msanii",
        "thCategory": "Kategoria",
        "thPrice": "Bei",
        "thViews": "Watazamaji",
        "thLikes": "Vipendwa",
        "thAction": "Hatua",
        "shortBadge": "Short",
        "watchVideo": "Tazama Video"
      },
      "analytics": {
        "title": "Mwenendo wa Utazamaji & Ushiriki",
        "subtitle": "Takwimu halisi za watazamaji na mwingiliano wa video za Kicheko",
        "viewsTab": "Watazamaji (Views)",
        "revenueTab": "Mapato (TZS)",
        "likesTab": "Vipendwa (Likes)",
        "watchTime": "Muda wa Kutazama",
        "avgPerVideo": "Wastani kwa Video",
        "returnRate": "Kiwango cha Kurudia",
        "viewsLabel": "Watazamaji (Maelfu)",
        "revenueLabel": "Mapato (Milioni TZS)",
        "likesLabel": "Vipendwa (Maelfu)",
        "months": "Jan,Feb,Mac,Apr,Mei,Jun,Jul,Ago,Sep,Okt,Nov,Des"
      },
      "cards": {
        "monthlyEarnings": "Mapato ya Kila Mwezi",
        "lastMonth": "mwezi uliopita",
        "viewAllProjects": "Tazama miradi yote",
        "revenueByRegion": "Mapato kwa Mikoa Inayoongoza",
        "topRegion": "Mkoa Unaongoza",
        "revenueByLocation": "Mapato kwa eneo",
        "countries": "Nchi",
        "revenueReport": "Ripoti ya Mapato",
        "totalEarnings": "Jumla ya mapato",
        "earningsThisMonth": "Mapato mwezi huu",
        "expenseThisMonth": "Matumizi mwezi huu",
        "timeline": "Ratiba ya Matukio",
        "yearlyBreakup": "Mgawanyo wa Mwaka",
        "lastYear": "mwaka uliopita",
        "earnings": "Mapato",
        "profit": "Faida",
        "sinceLastMonth": "tangu mwezi uliopita"
      },
      "metrics": {
        "openInvoices": "Ankara zilizo wazi",
        "ongoingProjects": "Miradi inayoendelea",
        "employees": "Wafanyakazi",
        "newProfit": "Faida mpya"
      },
      "timeline": {
        "updatedStatusOf": "amesasisha hali ya",
        "toAwaitingResponse": "kuwa inasubiri majibu ya mteja",
        "addedToGroup": "ameongezwa kwenye kikundi",
        "groupNamed": "jina la kikundi ni {name}",
        "openedShowcase": "amefungua maonesho mapya",
        "withTheme": "yenye mandhari {theme}",
        "updatedStatusTo": "amesasisha hali kuwa inasubiri majibu ya mteja",
        "projectWord": "Mradi",
        "wasCreated": "umeundwa"
      },
      "navbar": {
        "applicationsTitle": "Maombi ya Wachekeshaji",
        "applications": "Maombi",
        "toLight": "Badili kwenda mwanga",
        "toDark": "Badili kwenda giza"
      },
      "ytNav": {
        "toggleMenu": "Fungua/funga menyu",
        "searchPlaceholder": "Tafuta video za vichekesho, wasanii, skits...",
        "searchPlaceholderMobile": "Tafuta video za vichekesho...",
        "uploadVideo": "Pakia Video",
        "defaultUser": "Mtumiaji wa Kicheko",
        "avatarAlt": "Picha ya mtumiaji",
        "loggedOut": "Umetoka kwenye akaunti yako salama."
      }
    }
  }
}
